jPar.loginAndRegistration = jPar.loginAndRegistration || {};
deepMerge(true, jPar.loginAndRegistration, {
	passwordPage: {
		init: function init() {
			jPar.wdk.forms.init();
			this.trackingInit();

			try {
				jPar.wdk.passwordRestrictionBox.init();
				document.querySelector('#passwordForm').addEventListener('submit', (event) => {
					this.validatePassword();

					if (jPar.wdk.forms.hasVisibleErrors(document.querySelector('#passwordForm'))) {
						event.preventDefault();
					}
				});
			} catch (e) {
				jPar.util.log.error(e.stack, 'jPar.loginAndRegistration.passwordPage.init: low prio failed');
			}
		},

		validatePassword: function validatePassword() {
			jPar.wdk.passwordRestrictionBox.checkPasswordRestrictions();

			const passwordEmptyError = document.querySelector('#passwordEmptyError');
			const passwordNotValidError = document.querySelector('#passwordNotValidError');

			if (jPar.util.validate.textfieldIsEmpty(document.querySelector('#passFormPassword'))) {
				jPar.wdk.forms.showError(passwordEmptyError);
				jPar.wdk.forms.hideError(passwordNotValidError);
			} else if (jPar.wdk.passwordRestrictionBox.isPasswordValid() === false) {
				jPar.wdk.forms.showError(passwordNotValidError);
				jPar.wdk.forms.hideError(passwordEmptyError);
			} else {
				jPar.wdk.forms.hideError(passwordNotValidError);
				jPar.wdk.forms.hideError(passwordEmptyError);
			}
		},

		trackingInit() {
			jPar.util.log.bigData({
				category: 'registration',
				subcategory: 'password_start_screen',
				action: 'view',
			});

			document.querySelector('#passwordForm').addEventListener('submit', () => {
				jPar.util.log.bigData({
					category: 'registration',
					subcategory: 'password_start_screen',
					action: 'submit',
					targetId: 'button_password',
				});
			});
		},
	},
});
